import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

type DeleteAllVersionsModalProps = {
  open: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const DeleteAllVersionsModal = ({
  open,
  isLoading,
  onCancel,
  onConfirm,
}: DeleteAllVersionsModalProps) => (
  <Modal.Root open={open} onOpenChange={(next) => !next && onCancel()}>
    <Modal.Content useCustomOverlay size="small">
      <StatusModal type="danger" title="Delete all versions?">
        All versions of this closing will be permanently deleted. This action
        cannot be undone.
      </StatusModal>
      <Modal.FooterButtonGroup>
        <Button customType="secondary" onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          customType="danger"
          onClick={onConfirm}
          isLoading={isLoading}
          disabled={isLoading}
        >
          Delete all versions
        </Button>
      </Modal.FooterButtonGroup>
    </Modal.Content>
  </Modal.Root>
);
